

export const MAIL_TEMPLATE = `<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office">
<meta charset="utf-8"> 
<p>
<p style="margin-left:0in;text-align:left;">
    親愛的 [[NAME]]
</p>
<p style="margin-left:0in;text-align:left;">
    感謝您登記，您所登記的活动及時間為：
</p>
<p style="margin-left:0in;text-align:left;">
    活动 ：[[ACTIVITY]]
</p>
<p style="margin-left:0in;text-align:left;">
    日期及時間：[[DAY]]([[WEEK]]) [[START_TIME]] - [[END_TIME]]
</p>
<p style="margin-left:0in;">
    TEST
</p>
</p>
12345678
<p>
<br />
</p>
</html>`